/*
 * Copyright (c) GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */


import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {EngTranDtlRptComponent} from './components/admin/eng-tran-dtl-rpt/eng-tran-dtl-rpt.component';
import {ManageArchDeviancesComponent} from './components/admin/manage-arch-deviances/manage-arch-deviances.component';
import {
  EngineAttributesComponent
} from './components/admin/manage-attributes/engine-attributes/engine-attributes.component';
import {
  ManageTransmissionsComponent
} from './components/admin/manage-attributes/manage-transmissions/manage-transmissions.component';
import {
  VehicleAttributesComponent
} from './components/admin/manage-attributes/vehicle-attributes/vehicle-attributes.component';
import {ManageForecastStateComponent} from './components/admin/manage-forecast-state/manage-forecast-state.component';
import {
  EditAddGlobalScenarioComponent
} from './components/admin/manage-global-scenario/edit-add-global-scenario/edit-add-global-scenario.component';
import {
  ManageGlobalScenarioComponent
} from './components/admin/manage-global-scenario/manage-global-scenario.component';
import {
  ManageMarketAreaGroupingComponent
} from './components/manage/manage-market-area-grouping/manage-market-area-grouping.component';
import {
  ManageMarketingDivisionsComponent
} from './components/admin/manage-marketing-divisions/manage-marketing-divisions.component';
import {
  ManagePlanningMarketComponent
} from './components/admin/manage-planning-market/manage-planning-market.component';
import {
  ManagePropulsionTypesComponent
} from './components/admin/manage-propulsion-types/manage-propulsion-types.component';
import {ManageSalesLagComponent} from './components/admin/manage-sales-lag/manage-sales-lag.component';
import {
  ManageScenarioCategoryListComponent
} from './components/admin/manage-scenario-category-list/manage-scenario-category-list.component';
import {
  ManageScenarioTypeListComponent
} from './components/admin/manage-scenario-type-list/manage-scenario-type-list.component';
import {ManageScenariosComponent} from './components/admin/manage-scenarios/manage-scenarios.component';
import {ManageSubregionsComponent} from './components/admin/manage-subregions/manage-subregions.component';
import {
  PropulsionDuplicateCheckComponent
} from './components/admin/propulsion-duplicate-check/propulsion-duplicate-check.component';
import {
  PropulsionPortfolioLoadComponent
} from './components/admin/propulsion-portfolio-load/propulsion-portfolio-load.component';
import {PropulsionSnapshotComponent} from './components/admin/propulsion-snapshot/propulsion-snapshot.component';
import {SegmentReportComponent} from './components/admin/segment-report/segment-report/segment-report.component';
import {
  SegmentSchemeManagementComponent
} from './components/admin/segment-scheme-management/segment-scheme-management.component';
import {
  SharedRemoveObsoleteRecordsComponent
} from './components/admin/shared-remove-obsolete-records/shared-remove-obsolete-records.component';
import {AddUserComponent} from './components/admin/user-maintenance/add-user/add-user.component';
import {EditUserComponent} from './components/admin/user-maintenance/edit-user/edit-user.component';
import {UserMaintenanceComponent} from './components/admin/user-maintenance/user-maintenance.component';
import {
  VehicleDuplicateCheckComponent
} from './components/admin/vehicle-duplicate-check/vehicle-duplicate-check.component';
import {
  VehiclePortfolioArchiveComponent
} from './components/admin/vehicle-portfolio-archive/vehicle-portfolio-archive.component';
import {
  VehiclePortfolioLoadComponent
} from './components/admin/vehicle-portfolio-load/vehicle-portfolio-load.component';
import {
  VehiclePortfolioTransferComponent
} from './components/admin/vehicle-portfolio-transfer/vehicle-portfolio-transfer.component';
import {VehicleSnapshotComponent} from './components/admin/vehicle-snapshot/vehicle-snapshot.component';
import {HomeComponent} from './components/home/home.component';
import {
  CreateIndustryScenarioComponent
} from './components/industry-scenario/create-industry-scenario/create-industry-scenario.component';
import {
  IndustryQuerySaveComponent
} from './components/industry-scenario/forecast-template-save/industry-query-save.component';
import {
  BulkUpdateToPortfolioComponent
} from "./components/manage/bulk-update-to-portfolio/bulk-update-to-portfolio.component";
import {ManageBrandFamilyComponent} from './components/manage/manage-brand-family/manage-brand-family.component';
import {
  ManageIndustryScenarioComponent
} from './components/manage/manage-scenario-details/industry-scenario/manage-industry-scenario.component';
import {
  PropulsionScenarioComponent
} from './components/manage/manage-scenario-details/propulsion-scenario/propulsion-scenario.component';
import {
  ManageVehicleScenarioComponent
} from './components/manage/manage-scenario-details/vehicle-scenario/manage-vehicle-scenario.component';
import {
  CreatePropulsionForecastTemplateComponent
} from './components/propulsion-scenario/create-propulsion-forecast-template/create-propulsion-forecast-template.component';
import {
  CreatePropulsionScenarioComponent
} from './components/propulsion-scenario/create-scenario/create-propulsion-scenario.component';
import {
  DeletePropDetailComponent
} from './components/propulsion-scenario/delete-prop-detail/delete-prop-detail.component';
import {
  PropulsionTemplateSaveComponent
} from './components/propulsion-scenario/forecast-template-save/propulsion-template-save.component';
import {
  ImportGlobalPropulsionForecastComponent
} from './components/propulsion-scenario/import-global-propulsion-forecast/import-global-propulsion-forecast.component';
import {
  UpdatePropulsionScenarioWithExtDataComponent
} from './components/propulsion-scenario/update-propulsion-scenario-with-ext-data/update-propulsion-scenario-with-ext-data.component';
import {
  UpdatePropulsionScenarioWithScenarioComponent
} from './components/propulsion-scenario/update-propulsion-scenario-with-scenario/update-propulsion-scenario-with-scenario.component';
import {ComparePropVolRptComponent} from './components/reports/compare-prop-vol-rpt/compare-prop-vol-rpt.component';
import {
  GlobalPropulsionForecastTemplateComponent
} from "./components/reports/global-propulsion-forecast-template/global-propulsion-forecast-template";
import {
  GlobalScenarioAssociationsComponent
} from './components/reports/global-scenario-associations/global-scenario-associations.component';
import {
  GlobalSegShrAuditRptComponent
} from "./components/reports/global-seg-shr-audit-rpt/global-seg-shr-audit-rpt.component";
import {
  GlobalVehicleForecastTemplateComponent
} from './components/reports/global-vehicle-forecast-template/global-vehicle-forecast-template.component';
import {
  IndustryConsolidationReportComponent
} from "./components/reports/industry-consolidation-report/industry-consolidation-report.component";
import {
  MarketShareSgmntRptComponent
} from './components/reports/market-share-sgmnt-rpt/market-share-sgmnt-rpt.component';
import {
  PivotTableDataPropulsionComponent
} from './components/reports/pivot-table-data-propulsion/pivot-table-data-propulsion.component';
import {
  PivotTableDataVehicleComponent
} from './components/reports/pivot-table-data-vehicle/pivot-table-data-vehicle.component';
import {PortfolioReportsComponent} from './components/reports/portfolio-reports/portfolio-reports.component';
import {
  PropulsionConsolidationReportComponent
} from "./components/reports/propulsion-consolidation-report/propulsion-consolidation-report.component";
import {
  PrgmCodeByFuelTypeShareRptComponent
} from './components/reports/prgm-code-by-fuel-type-share-rpt/prgm-code-by-fuel-type-share-rpt.component';
import {
  RunRatesDatesReportComponent
} from './components/reports/run-rates-dates-report/run-rates-dates-report.component';
import {
  VarianceMktDivSgmntRptComponent
} from './components/reports/variance-mkt-div-sgmnt-rpt/variance-mkt-div-sgmnt-rpt.component';
import {VehPropVolCompareComponent} from './components/reports/veh-prop-vol-compare/veh-prop-vol-compare.component';
import {VehVolAnalysisRptComponent} from './components/reports/veh-vol-analysis-rpt/veh-vol-analysis-rpt.component';
import {
  VehicleConsolidationReportComponent
} from './components/reports/vehicle-consolidation-report/vehicle-consolidation-report.component';
import {
  CreateVehicleScenarioComponent
} from './components/vehicle-scenario/create-vehicle-scenario/create-vehicle-scenario.component';
import {DeleteVehDetailComponent} from './components/vehicle-scenario/delete-veh-detail/delete-veh-detail.component';
import {QueryVehicleComponent} from "./components/vehicle-scenario/query-vehicle/query-vehicle.component";
import {
  SaveGlobalVehicleTemplateComponent
} from './components/vehicle-scenario/save-global-vehicle-template/save-global-vehicle-template.component';
import {
  UpdateVehicleScenarioWithExtDataComponent
} from './components/vehicle-scenario/update-vehicle-scenario-with-ext-data/update-vehicle-scenario-with-ext-data.component';
import {
  UpdateVehicleScenarioWithScenarioComponent
} from './components/vehicle-scenario/update-vehicle-scenario-with-scenario/update-vehicle-scenario-with-scenario.component';
import {
  VehicleForecastTemplateSaveComponent
} from "./components/vehicle-scenario/vehicle-forecast-template-save/vehicle-forecast-template-save.component";


import {AuthErrorComponent} from './core/components/auth-error/auth-error.component';
import {UserPreferenceComponent} from './core/components/user-preference/user-preference.component';

const routes: Routes = [
  {
    path: 'auth-error',
    component: AuthErrorComponent
  },
  {
    path: 'user-preference',
    component: UserPreferenceComponent
  },
  {
    path: 'segment-scheme-editor',
    component: SegmentSchemeManagementComponent
  },
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'vehicle',
    children: [
      {
        path: 'update-with-scen',
        component: UpdateVehicleScenarioWithScenarioComponent
      },
      {
        path: 'update-with-ext-data',
        component: UpdateVehicleScenarioWithExtDataComponent
      },
      {
        path: 'forecast-template',
        children: [
          {
            path: 'create',
            component: QueryVehicleComponent
          },
          {
            path: 'save',
            component: VehicleForecastTemplateSaveComponent
          }
        ]
      },
      {
        path: 'global-forecast-template',
        children: [
          {
            path: 'import',
            component: SaveGlobalVehicleTemplateComponent
          }
        ]
      },
      {
        path: 'pivot-table-data',
        component: PivotTableDataVehicleComponent
      },
      {
        path: 'create-scenario',
        component: CreateVehicleScenarioComponent
      },
      {
        path: 'delete-veh-details',
        component: DeleteVehDetailComponent
      }
    ]
  },
  {
    path: 'industry',
    children: [
      {
        path: 'forecast-template',
        children: [
          {
            path: 'save',
            component: IndustryQuerySaveComponent
          }
        ]
      },
      {
        path: 'create-scenario',
        component: CreateIndustryScenarioComponent
      }
    ]
  },
  {
    path: 'propulsion',
    children: [
      {
        path: 'update-with-scen',
        component: UpdatePropulsionScenarioWithScenarioComponent
      },
      {
        path: 'update-with-ext-data',
        component: UpdatePropulsionScenarioWithExtDataComponent
      },
      {
        path: 'forecast-template',
        children: [
          {
            path: 'create',
            component: CreatePropulsionForecastTemplateComponent
          },
          {
            path: 'save',
            component: PropulsionTemplateSaveComponent
          }
        ]
      },
      {
        path: 'global-forecast-template',
        children: [
          {
            path: 'import',
            component: ImportGlobalPropulsionForecastComponent
          }
        ]
      },
      {
        path: 'pivot-table-data',
        component: PivotTableDataPropulsionComponent
      },
      {
        path: 'create-scenario',
        component: CreatePropulsionScenarioComponent
      },
      {
        path: 'delete-prop-details',
        component: DeletePropDetailComponent
      }
    ]
  },
  {
    path: 'add-user',
    component: AddUserComponent
  },
  {
    path: 'edit-user',
    component: EditUserComponent
  },
  {
    path: 'manage-brand-family',
    component: ManageBrandFamilyComponent
  },
  {
    path: 'edit-global-scenario',
    component: EditAddGlobalScenarioComponent
  },
  {
    path: 'bulk-update-to-portfolio',
    component: BulkUpdateToPortfolioComponent
  },
  {
    path: 'update',
    children: [
      {
        path: 'manage-scenario-details',
        children: [
          {
            path: 'industry-scenarios',
            component: ManageIndustryScenarioComponent
          },
          {
            path: 'propulsion-scenarios',
            component: PropulsionScenarioComponent
          },
          {
            path: 'vehicle-scenarios',
            component: ManageVehicleScenarioComponent
          }
        ]
      }
    ]
  },
  {
    path: 'report',
    children: [
      {
        path: 'market-share-sgmnt-rpt',
        component: MarketShareSgmntRptComponent
      },
      {
        path: 'global-propulsion-forecast-template',
        component: GlobalPropulsionForecastTemplateComponent
      },
      {
        path: 'global-vehicle-forecast-template',
        component: GlobalVehicleForecastTemplateComponent
      },
      {
        path: 'veh-consolidation-report',
        component: VehicleConsolidationReportComponent
      },
      {
        path: 'global-scenario-associations',
        component: GlobalScenarioAssociationsComponent
      },
      {
        path: 'global-seg-shr-audit-rpt',
        component: GlobalSegShrAuditRptComponent
      },
      {
        path: 'industry-consolidation-report',
        component: IndustryConsolidationReportComponent
      },
      {
        path: 'run-rates-dates-report',
        component: RunRatesDatesReportComponent
      },
      {
        path: 'propulsion-consolidation-report',
        component: PropulsionConsolidationReportComponent
      },
      {
        path: 'veh-prop-vol-compare',
        component: VehPropVolCompareComponent
      },
      {
        path: 'veh-vol-analysis-rpt',
        component: VehVolAnalysisRptComponent
      },
      {
        path: 'variance-mkt-div-sgmnt-rpt',
        component: VarianceMktDivSgmntRptComponent
      },
      {
        path: 'portfolio',
        component: PortfolioReportsComponent
      },
      {
        path: 'compare-prop-vol-rpt',
        component: ComparePropVolRptComponent
      },
      {
        path: 'prgm-code-by-fuel-type-share-rpt',
        component: PrgmCodeByFuelTypeShareRptComponent
      }
    ]
  },
  {
    path: 'admin',
    children: [
      {
        path: 'eng-tran-dtl-report',
        component: EngTranDtlRptComponent
      },
      {
        path: 'segment-scheme-editor',
        component: SegmentSchemeManagementComponent
      },
      {
        path: 'user-maintenance',
        component: UserMaintenanceComponent
      },
      {
        path: 'manage-scenario-type-list',
        component: ManageScenarioTypeListComponent
      },
      {
        path: 'manage-forecast-state',
        component: ManageForecastStateComponent
      },
      {
        path: 'manage-gfs-vehicles',
        children: [
          {
            path: 'remove-obsolete-records',
            component: SharedRemoveObsoleteRecordsComponent
          },
          {
            path: 'segment-report',
            component: SegmentReportComponent
          },
          {
            path: 'manage-sales-lag',
            component: ManageSalesLagComponent
          }
        ]
      },
      {
        path: 'load-new-portfolio',
        children: [
          {
            path: 'vehicle-portfolio',
            children: [
              {
                path: 'load-vehicle-portfolio',
                component: VehiclePortfolioLoadComponent
              },
              {
                path: 'process-vehicle-snapshot',
                component: VehicleSnapshotComponent
              },
              {
                path: 'portfolio-transfer',
                component: VehiclePortfolioTransferComponent
              },
              {
                path: 'portfolio-archive',
                component: VehiclePortfolioArchiveComponent
              },
            ]
          },
          {
            path: 'propulsion-portfolio',
            children: [
              {
                path: 'load-propulsion-portfolio',
                component: PropulsionPortfolioLoadComponent
              },
              {
                path: 'process-propulsion-snapshot',
                component: PropulsionSnapshotComponent
              }
            ]
          }
        ]
      },
      {
        path: 'manage-attributes',
        children: [
          {
            path: 'vehicle-attributes',
            component: VehicleAttributesComponent
          },
          {
            path: 'engine-attributes',
            component: EngineAttributesComponent
          },
          {
            path: 'transmission-attributes',
            component: ManageTransmissionsComponent
          }
        ]
      },
      {
        path: 'manage-subregions',
        component: ManageSubregionsComponent
      },
      {
        path: 'manage-scenario-category-list',
        component: ManageScenarioCategoryListComponent
      },
      {
        path: 'manage-propulsion-types',
        component: ManagePropulsionTypesComponent
      },
      {
        path: 'manage-marketing-divisions',
        component: ManageMarketingDivisionsComponent
      },
      {
        path: 'manage-planning-market',
        component: ManagePlanningMarketComponent
      },
      {
        path: 'manage-market-area-grouping',
        component: ManageMarketAreaGroupingComponent
      },
      {
        path: 'manage-arch-deviances',
        component: ManageArchDeviancesComponent
      },
      {
        path: 'manage-global-scenarios',
        component: ManageGlobalScenarioComponent
      },
      {
        path: 'manage-scenarios',
        component: ManageScenariosComponent
      },
      {
        path: 'duplicate-check',
        children: [
          {
            path: 'vehicle',
            component: VehicleDuplicateCheckComponent
          },
          {
            path: 'propulsion',
            component: PropulsionDuplicateCheckComponent
          }
        ]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
